import { Component, OnInit, OnDestroy }  from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import { TAFBookB1Service } from './taf-book-b1.service';
import { ITAFBookB1 } from './taf-book-b1-list';

import {DataTable} from 'primeng/primeng';
import {Column} from 'primeng/primeng';
import {Header} from 'primeng/primeng';
import {Button} from 'primeng/primeng';


@Component({
    //templateUrl: 'app/system-management/tafbooks/taf-book-b1/taf-book-b1.component.html',
    template: require('./taf-book-b1.component.html'),
    directives: [ROUTER_DIRECTIVES,DataTable,Column, Header],
    
})

export class TAFBookB1Component implements OnInit, OnDestroy{
    pageTitle: string = 'TAF BOOK b1';
    errorMessage: string;
    tafBookB1Arr: ITAFBookB1;
   
    constructor(private route: ActivatedRoute,
                private router: Router,
                private _tafBookB1Service: TAFBookB1Service) {
                    
    }

    ngOnInit(): void{
        this._tafBookB1Service.getTAFBookB1()
         .subscribe(
                tafBookB1Arr => this.tafBookB1Arr = tafBookB1Arr,
                error =>  this.errorMessage = <any>error);
    }

    ngOnDestroy() {
        //alert("onDestroy");
        //this.sub.unsubscribe();
   }
   
}


/** WEBPACK FOOTER **
 ** ./app/system-management/tafbooks/taf-book-b1/taf-book-b1.component.ts
 **/